// Core wraps every list as { items, pagination: { total, limit, offset } }.
// A bare array is tolerated (and flagged) so a contract drift degrades to a
// visible warning instead of a blank screen.
export function normalizeList(data, normalizeItem = (item) => item) {
    if (Array.isArray(data)) {
        return { items: data.map(normalizeItem), total: data.length, limit: data.length, offset: 0, hasMore: false, isLegacyShape: true };
    }
    const rawItems = Array.isArray(data?.items) ? data.items : [];
    const pagination = data?.pagination || {};
    const items = rawItems.map(normalizeItem);
    const total = Number.isFinite(pagination.total) ? pagination.total : items.length;
    const limit = Number.isFinite(pagination.limit) ? pagination.limit : items.length;
    const offset = Number.isFinite(pagination.offset) ? pagination.offset : 0;
    return { items, total, limit, offset, hasMore: offset + items.length < total, isLegacyShape: false };
}

export function toId(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'object') return toId(value.id);
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
}

export function toText(value, fallback = '') {
    if (value == null) return fallback;
    return typeof value === 'string' ? value : String(value);
}

export function toArray(value) {
    return Array.isArray(value) ? value : [];
}
